<template>
    <div class="functions">
      <div class="mainContent">
        <div class="title text-center">windows 版本/预览</div>
        <img :src="mainPng" alt="" style="display: inline-block" />
      </div>
    </div>
  </template>
  <script setup>
  import { onMounted } from "vue";
  import mainPng from "@/assets/imgs/replay/main.png";


  
  onMounted(() => {});
  </script>
  <style scoped>
  .functions {
    background-color: #f7f7f7;
  }
  
  .mainContent {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding: 2rem 0 5rem;
    text-align: center;
  }
  
  .title {
    font-size: 1.25rem;
    margin-bottom: 3.5rem;
    font-weight: 500;
    line-height: 1.2;
    color:#131313
  }
  
  
  @media (max-width: 768px) {
  }
  </style>